export const SEGMENTS = [
  {
    slug: "residential",
    title: "Rumah & Perumahan",
    tagline: "Rumah pribadi · Kos · Apartemen",
    description:
      "Instalasi & perbaikan listrik untuk hunian — aman, rapi, dan bergaransi. Termasuk kos-kosan dan apartemen.",
    keywords: ["jasa listrik rumah batam", "jasa listrik perumahan batam"],
    icon: "home",
  },
  {
    slug: "commercial",
    title: "Ruko & Usaha",
    tagline: "Ruko · Toko · Kafe · UMKM",
    description:
      "Instalasi komersial untuk ruko, toko, kafe, dan usaha kecil-menengah. Panel, lighting, stop kontak heavy-duty, CCTV.",
    keywords: ["jasa listrik ruko batam", "instalasi listrik toko batam"],
    icon: "store",
  },
  {
    slug: "office",
    title: "Gedung & Kantor",
    tagline: "Perkantoran · Hotel · Co-working",
    description:
      "Layanan listrik untuk gedung kantor, hotel, dan perkantoran modern. Termasuk sistem pencahayaan dan panel distribusi.",
    keywords: ["jasa listrik gedung batam", "jasa listrik kantor batam"],
    icon: "building-2",
  },
  {
    slug: "industrial",
    title: "Industri & Pabrik",
    tagline: "Pabrik · Gudang · Workshop",
    description:
      "Panel MDB/SDB/MCC, ATS-AMF genset, capacitor bank, maintenance pabrik, dan grounding area produksi.",
    keywords: ["jasa listrik pabrik batam", "teknisi listrik industri batam"],
    icon: "factory",
  },
  {
    slug: "government",
    title: "Instansi Pemerintah",
    tagline: "Kantor pemerintah · Sekolah · RS · Fasum",
    description:
      "Proyek dan maintenance kelistrikan untuk instansi pemerintah, sekolah, rumah sakit, dan fasilitas umum.",
    keywords: ["jasa listrik kantor pemerintah batam", "jasa listrik sekolah batam"],
    icon: "landmark",
  },
];
